module.exports = __webpack_public_path__ + "static/media/back_sided-new.8f8c0517.png";